// extracted by mini-css-extract-plugin
export default {"NonFieldErrors":"Form_NonFieldErrors__el6fn"};